import { useLocation, Navigate, Outlet } from "react-router-dom";
import useAuth from "../hooks/useAuth";

// By the time this renders, PersistLogin has already finished its refresh attempt,
// so auth state is fully determined — no setTimeout hacks needed.
const RequireAuth = ({ allowedRoles }) => {
  const { auth } = useAuth();
  const location = useLocation();

  // Accept token from auth context (set by PersistLogin refresh) or from
  // localStorage (set on login / hydrated by AuthProvider on page load).
  const hasValidToken =
    auth?.accessToken || localStorage.getItem("accessToken");

  if (!hasValidToken) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // If first login, redirect to change password (except if already on change-password)
  if (auth?.isFirstLogin && location.pathname !== "/change-password") {
    console.log(
      "[RequireAuth] First login detected, redirecting to change password",
    );
    return <Navigate to="/change-password" replace />;
  }

  // If roles are required, check them
  if (allowedRoles?.length) {
    const hasRole = auth?.roles?.some((role) => allowedRoles.includes(role));
    if (!hasRole) {
      console.log("[RequireAuth] Insufficient roles");
      return <Navigate to="/unauthorized" state={{ from: location }} replace />;
    }
  }

  console.log("[RequireAuth] Auth check passed");
  return <Outlet />;
};

export default RequireAuth;
